import React from 'react';
import { authRole } from '../../shared/constants/AppConst';
import { Redirect } from 'react-router-dom';

export const appsConfig = [
  {
    auth: authRole.user,
    routes: [
      {
        path: [
          '/apps/projects/:id/section/:sectionId/task/:taskId',
          '/apps/projects/:id',
          '/apps/projects',
        ],
        component: React.lazy(() => import('./ProjectBoard')),
      },
      // {
      //   path: '/apps/contact',
      //   component: React.lazy(() => import('./Contact')),
      // },
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/releases',
        component: React.lazy(() => import('./Releases')),
      }
    ],
  },
];
